"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.REQUEST = exports.SAGA = void 0;
var SAGA = 'apiFlow/userPermissions/changeStatus/SAGA';
exports.SAGA = SAGA;
var REQUEST = 'apiFlow/userPermissions/changeStatus/REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'apiFlow/userPermissions/changeStatus/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/userPermissions/changeStatus/FAILURE';
exports.FAILURE = FAILURE;